import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ManagerService } from 'src/app/services/manager.service';
import { NavComponent } from 'src/app/traits/nav/nav.component';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.sass']
})
export class PaymentDetailsComponent implements OnInit {
  page: any; accnt: any; id: string; rpt: any; statements: any;
  add: boolean; accounts: any[] = []; trans: any[] = []; response: any; search: string = '';

  private _searhcTitle: string;

  get searchTitle(): string {
    return this._searhcTitle;
  }
  set searchTitle(value: string) {
    this._searhcTitle = value;
  }

  constructor(
    private api: ApiService, 
    private _use: NavComponent, 
    private _api: ManagerService, 
    private rout: Router, 
    private router: ActivatedRoute,
    ) { }

  ngOnInit() {
    this.id = this.router.snapshot.paramMap.get('id');
    this.getDetails(this.id);
    this.rpt = { id: '', type: '', start: '', end: '', code: 0 }
  }


  getDetails(id: any) {
    this.api.get("Page/Put/"+id).subscribe((data: any) => {
      this.page = data.data; this.accounts = data.accounts;
      this.trans = data.payments;
      console.log(data);
      this._use.showMsg('success', 'Request fetched', 'Page Details Fetched');
    }, (err: HttpErrorResponse) => {
      this._use.showMsg('error', 'Request Failed', 'Unable to fetch Page Details');
    });
  }


}




